function keepBlockBoundaries(events, bounds) {
  if (!bounds || !events.length) return events;
  const start = Date.parse(bounds.startUTC), end = Date.parse(bounds.endUTC);
  const bounded = events.map((event, index) => ({...event,
    ...(index === 0 ? {startUTC: bounds.startUTC} : {}),
    ...(index === events.length - 1 ? {endUTC: bounds.endUTC} : {}),
  }));
  if (!Number.isFinite(start) || !Number.isFinite(end) || bounded.some(event =>
    !Number.isFinite(Date.parse(event.startUTC)) || !Number.isFinite(Date.parse(event.endUTC)) ||
    Date.parse(event.startUTC) < start || Date.parse(event.endUTC) > end ||
    Date.parse(event.endUTC) - Date.parse(event.startUTC) < 60000)) {
    throw new Error('Keep events within the original time block, with at least one minute for each event.');
  }
  return bounded;
}

export function arrangeConsecutiveEvents(events, bounds) {
  const arranged = events.reduce((result, event) => {
    const previous = result[result.length - 1];
    const duration = Date.parse(event.endUTC) - Date.parse(event.startUTC);
    if (!previous || !Number.isFinite(Date.parse(previous.endUTC)) || !(duration > 0)) return [...result, event];
    return [...result, {...event, startUTC: previous.endUTC, endUTC: new Date(Date.parse(previous.endUTC) + duration).toISOString()}];
  }, []);
  return keepBlockBoundaries(arranged, bounds);
}

export function updateBlockEvent(events, next, consecutive, bounds) {
  const index = events.findIndex(event => event.eventId === next.eventId);
  if (index < 0) return events;
  const updated = events.map((event, i) => i === index ? next : event);
  const arranged = consecutive ? [...updated.slice(0, index), ...arrangeConsecutiveEvents(updated.slice(index))] : updated;
  return keepBlockBoundaries(arranged, bounds);
}
// Repartition the selected block while retaining each tab's identity and details.
export function divideEventBlock(startUTC, endUTC, count, events, makeEvent) {
  const start = Date.parse(startUTC), end = Date.parse(endUTC);
  if (!Number.isFinite(start) || !Number.isFinite(end) || !Number.isInteger(count) || count < 1 || count > 24 || end - start < count * 60000) {
    throw new Error("Choose up to 24 events, with at least one minute for each event.");
  }
  const minutes = Math.floor((end - start) / 60000);
  return Array.from({length: count}, (_, index) => ({
    ...(events[index] || makeEvent()),
    startUTC: new Date(start + Math.floor(minutes * index / count) * 60000).toISOString(),
    endUTC: new Date(index === count - 1 ? end : start + Math.floor(minutes * (index + 1) / count) * 60000).toISOString(),
  }));
}
